export enum ChartTypes {
  CANDLESTICKS = 'candlesticks',
}



// WEBPACK FOOTER //
// ./src/app/chart/chart.types.ts